import styled from 'styled-components';

export const TableHeader = styled.thead`
  background: #ededf0;
  border-radius: 4px;

  th {
    font-weight: bold;
    text-align: left;
    padding: 14px 16px;
    border-bottom: 1px solid #d4d4d4;

    :nth-child(1) {
      width: 48px;
    }
    :nth-child(2) {
      width: 400px;
      text-align: left;
      padding-left: 8px;
    }

    :nth-child(3) {
      width: 100px;
      text-align: right;
    }
    :nth-child(4) {
      text-align: right;
    }
    :nth-child(5) {
      text-align: right;
    }
  }
`;
